<template>
  <div class="message" :data-testid="testid">
    <BranchLogo :branch="branch" class="brand" />
    <h1 v-if="title" class="title">{{ title }}</h1>
  </div>
</template>

<script>
import BranchLogo from './BranchLogo.vue';

export default {
  name: 'MessageScreen',
  components: { BranchLogo },
  props: {
    branch: { type: Object, default: null },
    title: { type: String, default: '' },
    testid: { type: String, default: '' }
  }
};
</script>

<style scoped>
.message {
  height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 4vh;
  background: #f5f3ff;
  padding: 4vh 4vw;
}
.brand ::v-deep .logo {
  max-height: 34vh;
  max-width: 60vw;
}
.brand ::v-deep .name {
  font-size: calc(2rem * var(--font-scale));
}
.title {
  margin: 0;
  font-size: calc(4.5rem * var(--font-scale));
  font-weight: 600;
  color: #4c1d95;
  text-align: center;
}
</style>
